import { GH } from '../theme';

export function ImagePlaceholder({ label, height = 300, dark = false, style = {} }) {
  return (
    <div style={{
      width: '100%', height,
      background: dark ? GH.colors.charcoal : GH.colors.surfaceLt,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      borderRadius: 2, ...style,
    }}>
      <span style={{
        fontFamily: GH.fonts.body, fontSize: 13, fontWeight: 500,
        color: dark ? GH.colors.onDark.muted : GH.colors.mutedDk,
        textAlign: 'center', padding: '0 20px',
      }}>{label}</span>
    </div>
  );
}
